import { Container, Row, Col, Button } from "react-bootstrap";
import "./StructBlock.css";
import { useHrStyles } from "../../Context/HRContext";

export default function StructBlock() {
  const hrStyles = useHrStyles();
  return (
    <Container className="Struct-Container">
      <Row className="justify-content-center align-items-center mb-5">
        <Col md={6} className="Struct-Text">
          <h1 className="Struct-Head">Foundation design</h1>
          <p className="Struct-Para">
            Ensuring a solid and reliable base for every structure, our
            foundation designs are tailored to the specific conditions of your
            site. We prioritize safety and stability to support the entire
            building with precision.
          </p>
          <Button
            href="/Contact"
            className="Struct-Button"
            variant="outline-success"
          >
            Contact Us
          </Button>
        </Col>
        <Col md={6}>
          <img
            src="/assets/images/s1.jpg"
            alt="Structural"
            style={{
              borderRadius: "25px",
              boxShadow: "8px 8px 5px rgba(0, 0, 0, 0.1)",
            }}
          />
        </Col>
      </Row>

      <Row className="justify-content-center align-items-center mb-3">
        <Col md={6}>
          <img
            src="/assets/images/s2.jpg"
            alt="Structural"
            style={{
              borderRadius: "25px",
              boxShadow: "8px 8px 5px rgba(0, 0, 0, 0.1)",
              marginBottom: "1em",
            }}
          />
        </Col>
        <Col md={6} className="Struct-Text">
          <h1 className="Struct-Head">Steel design</h1>
          <p className="Struct-Para">
            Utilizing the strength and flexibility of steel, we design
            structures that are both lightweight and highly durable. Our steel
            solutions are crafted to meet the highest standards of performance
            and efficiency.
          </p>
          <Button
            href="/Contact"
            className="Struct-Button"
            variant="outline-primary"
          >
            Contact Us
          </Button>
        </Col>
      </Row>

      <Row className="justify-content-center align-items-center mb-5">
        <Col md={6} className="Struct-Text">
          <h1 className="Struct-Head">Concrete design</h1>
          <p className="Struct-Para">
            Combining innovation with strength, our concrete designs offer
            long-lasting durability for a wide range of structures. We ensure
            that each design maximizes resilience and safety while meeting both
            aesthetic and functional goals.
          </p>
          <Button
            href="/Contact"
            className="Struct-Button"
            variant="outline-danger"
          >
            Contact Us
          </Button>
        </Col>
        <Col md={6}>
          <img
            src="/assets/images/s3.jpg"
            alt="Structural"
            style={{
              borderRadius: "25px",
              boxShadow: "8px 8px 5px rgba(0, 0, 0, 0.1)",
            }}
          />
        </Col>
      </Row>
      <hr style={hrStyles} />
    </Container>
  );
}
